(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-labels"] && !Shopify.designMode) return;
  try {
    class ProductLabels extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.#handleClick);
    }

    #handleClick = (event) => {
      const link = event.target.closest('a[href^="#"]');
      if (!link) return;

      const targetId = link.getAttribute('href').slice(1);
      if (!targetId) return;

      event.preventDefault();

      const target = document.getElementById(targetId);
      if (!target) return;

      const details =
        target.tagName === 'DETAILS'
          ? target
          : target.closest('details') || target.querySelector('details');

      if (details && !details.open) {
        details.open = true;
      }

      requestAnimationFrame(() => {
        const gap = 16;
        const header = document.querySelector('.header-section');
        const headerHeight = header ? header.getBoundingClientRect().height : 0;
        const desiredTop = headerHeight + gap;

        const stickyPanel = target.closest('.sticky-content--desktop, .sticky-content');
        if (stickyPanel && window.getComputedStyle(stickyPanel).position === 'sticky') {
          const container = stickyPanel.parentElement;
          const containerBottom =
            container.getBoundingClientRect().top + window.scrollY + container.offsetHeight;
          const panelHeight = stickyPanel.offsetHeight;
          const targetOffsetInPanel =
            target.getBoundingClientRect().top +
            window.scrollY -
            (stickyPanel.getBoundingClientRect().top + window.scrollY);

          const scrollTarget = containerBottom - panelHeight + targetOffsetInPanel - desiredTop;
          window.scrollTo({ top: Math.max(0, scrollTarget), behavior: 'smooth' });
        } else {
          const targetRect = target.getBoundingClientRect();
          const scrollTarget = window.scrollY + targetRect.top - desiredTop;
          window.scrollTo({ top: Math.max(0, scrollTarget), behavior: 'smooth' });
        }
      });
    };
  }

  if (!customElements.get('product-labels')) {
    customElements.define('product-labels', ProductLabels);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["review"] && !Shopify.designMode) return;
  try {
    class ProductReviewLink extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.#handleClick);
    }

    #handleClick = (event) => {
      const link = event.target.closest('a[href^="#"]');
      if (!link) return;

      const targetId = link.getAttribute('href').slice(1);
      if (!targetId) return;

      event.preventDefault();

      const target = document.getElementById(targetId);
      if (!target) return;

      requestAnimationFrame(() => {
        const gap = 16;
        const header = document.querySelector('.header-section');
        const headerHeight = header ? header.getBoundingClientRect().height : 0;
        const desiredTop = headerHeight + gap;

        const stickyPanel = target.closest('.sticky-content--desktop, .sticky-content');
        if (stickyPanel && window.getComputedStyle(stickyPanel).position === 'sticky') {
          const container = stickyPanel.parentElement;
          const containerBottom =
            container.getBoundingClientRect().top + window.scrollY + container.offsetHeight;
          const panelHeight = stickyPanel.offsetHeight;
          const targetOffsetInPanel =
            target.getBoundingClientRect().top +
            window.scrollY -
            (stickyPanel.getBoundingClientRect().top + window.scrollY);

          const scrollTarget = containerBottom - panelHeight + targetOffsetInPanel - desiredTop;
          window.scrollTo({ top: Math.max(0, scrollTarget), behavior: 'smooth' });
        } else {
          const targetRect = target.getBoundingClientRect();
          const scrollTarget = window.scrollY + targetRect.top - desiredTop;
          window.scrollTo({ top: Math.max(0, scrollTarget), behavior: 'smooth' });
        }
      });
    };
  }

  if (!customElements.get('product-review-link')) {
    customElements.define('product-review-link', ProductReviewLink);
  }
  } catch(e) { console.error(e); }
})();

})();
